export const INITIALIZE_HUB = 'initialize-hub';
const initializeHub = () => ({ type: INITIALIZE_HUB });
export default initializeHub;
